import React from 'react';
import { Spinner, AppLayoutBlank } from '@mc/ui-v4';
import { Route, Switch } from 'react-router-dom';
import { LOG_TAG } from '../const';
import {
  LoginPage,
  LoginPageProps,
  LoginRedirectPage,
} from '../pages/LoginPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { FallbackLoginRedirect } from './FallbackLoginRedirect';
import { useAuth } from '@mc/react-auth';
import { ROUTE_LOGIN } from '@mc/react-app-base';
import { AppNotAssignedPage } from '../pages/AppNotAssignedPage';

export const RouterWrap: React.FC<
  React.PropsWithChildren<{
    loginPageProps?: LoginPageProps;
    publicChildren?: React.ReactNode;
  }>
> = ({ children, publicChildren, loginPageProps }) => {
  const auth = useAuth();

  if (!auth.data) {
    // Waiting for auth
    if (__DEV__) {
      console.debug(LOG_TAG, '[RouterWrap]', 'waiting for auth to load');
    }

    return (
      <AppLayoutBlank horizontalCenter verticalCenter>
        <Spinner />
      </AppLayoutBlank>
    );
  }

  const loginRoute = (
    // @ts-ignore
    <Route
      key={'login'}
      path={ROUTE_LOGIN}
      component={(props: any) => <LoginPage {...loginPageProps} {...props} />}
    />
  );

  const loginFallbackRoute = (
    // @ts-ignore
    <Route
      key={'login-fallback-route'}
      path={'/login'}
      component={() => <LoginRedirectPage />}
    />
  );

  if (!auth.isLoggedIn) {
    if (__DEV__) {
      console.log('Není přihlášen, renderují se jen public routes');
    }
    return (
      // @ts-ignore
      <Switch>
        {publicChildren}
        {loginRoute}
        {loginFallbackRoute}
        {
          // @ts-ignore
          <Route key={'login-fallback'} component={FallbackLoginRedirect} />
        }
      </Switch>
    );
  }

  // @ts-ignore
  const appAssigned =
    auth.data.prirazenaAplikace === undefined ||
    auth.data.prirazenaAplikace === null
      ? true
      : auth.data.prirazenaAplikace;

  return (
    // @ts-ignore
    <Switch>
      {publicChildren}
      {loginRoute}
      {loginFallbackRoute}
      {appAssigned && children}
      {!appAssigned && (
        // @ts-ignore
        <Route
          exact={true}
          key={'app-not-assigned'}
          component={AppNotAssignedPage}
        />
      )}
      {appAssigned && (
        // @ts-ignore
        <Route exact={true} key={'not-found'} component={NotFoundPage} />
      )}
    </Switch>
  );
};
